import React, {useEffect, useRef} from 'react';
const useDropFiles = (css:{} | {cssSelectorKey:string, cssSelectorKeyValue:string, cssSelectorKeyValueDefault: string} = {}, getChosenFiles) => {
    const drop:React.RefObject<HTMLCanvasElement> = useRef(null);

    useEffect(() => {
        if ('current' in drop) {
            drop?.current?.addEventListener('dragover', handleDragOver);
            drop?.current?.addEventListener('dragleave', handleDragLeave);
            drop?.current?.addEventListener('drop', handleDrop);

            return () => {
                drop?.current?.removeEventListener('dragover', handleDragOver);
                drop?.current?.removeEventListener('drop', handleDrop);
                drop?.current?.addEventListener('dragleave', handleDragLeave);
            };
        }
    }, [drop]);

    /**
     * handleDragLeave - when user leave drag
     * @param e - browser event
     */
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if ('cssSelectorKey' in css) {
            e.target.style[css.cssSelectorKey] = css.cssSelectorKeyValueDefault;
        }
    };

    /**
     * handleDragOver - when user hover drag container
     * @param e - browser event
     */
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if ('cssSelectorKey' in css) {
            e.target.style[css.cssSelectorKey] = css.cssSelectorKeyValue;
        }
    };

    /**
     * handleDrop - when user drop files
     * @param e - browser event
     */
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const {files} = e.dataTransfer;

        if ('cssSelectorKey' in css) {
            e.target.style[css.cssSelectorKey] = css.cssSelectorKeyValueDefault;
        }

        if (files && files.length) {
            getChosenFiles(files);
        }
    };

    return {handleDrop, drop};

};

export default useDropFiles;
